import type { PageStatus } from "../pages/types";

const STATUS_CONFIG: Record<PageStatus, { label: string; className: string }> = {
  draft: {
    label: "Draft",
    className: "bg-amber-50 text-amber-700 border-amber-200",
  },
  published: {
    label: "Published",
    className: "bg-sage/10 text-sage border-sage/20",
  },
  archived: {
    label: "Archived",
    className: "bg-canvas-2 text-ink-4 border-ink-6",
  },
};

export function PageStatusPill({ status }: { status: PageStatus }) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;
  return (
    <span
      className={`hair inline-flex items-center rounded-full border px-2 py-0.5 text-[10.5px] font-medium leading-tight ${config.className}`}
    >
      {config.label}
    </span>
  );
}
